<div class="lookup-table">
  @if (items!.length > 0 || isAddingNewItem) {
    <table mat-table [dataSource]="dataSource" matSort (matSortChange)="onMatSortChange($event)" class="mat-elevation-z2">
      @for (column of getColumns(); track column.key) {
        <ng-container [matColumnDef]="column.key">
          @if (column.sortable !== false) {
            <th mat-header-cell *matHeaderCellDef mat-sort-header="{{column.key}}" [class.boolean-header]="isBooleanColumn(column.key)">{{ column.header }}</th>
          } @else {
            <th mat-header-cell *matHeaderCellDef [class.boolean-header]="isBooleanColumn(column.key)">{{ column.header }}</th>
          }
          <td mat-cell *matCellDef="let item" (click)="onItemClick(item)" [class.boolean-cell]="isBooleanColumn(column.key)">
            @if (isAddingThisItem(item) && isEditableColumn(column.key)) {
              <mat-form-field appearance="fill" class="edit-field">
                <input matInput
                       [(ngModel)]="editingValues[column.key]"
                       (keydown)="onAddKeyDown($event)"
                       [placeholder]="'Enter ' + column.header.toLowerCase() + '...'"
                       (click)="$event.stopPropagation()"
                       [type]="isNumberColumn(column.key) ? 'number' : 'text'"
                       appTextNormalize
                       #addInput>
              </mat-form-field>
            } @else if (isAddingThisItem(item) && isBooleanColumn(column.key) && column.editable) {
              <mat-checkbox [(ngModel)]="editingValues[column.key]"
                           (click)="$event.stopPropagation()"
                           class="boolean-checkbox">
              </mat-checkbox>
            } @else if (isAddingThisItem(item) && isSelectColumn(column.key) && column.editable) {
              <mat-form-field appearance="fill" class="edit-field">
                <mat-select [(ngModel)]="editingValues[column.key]"
                            (click)="$event.stopPropagation()"
                            [placeholder]="'Select ' + column.header.toLowerCase()"
                            [compareWith]="compareWith">
                  @for (option of getSelectOptions(column.key); track option.value) {
                    <mat-option [value]="option.value">{{ option.label }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            } @else if (isAddingThisItem(item) && isMultiSelectColumn(column.key) && column.editable) {
              <mat-form-field appearance="fill" class="edit-field">
                <mat-select [(ngModel)]="editingValues[column.key]"
                            (click)="$event.stopPropagation()"
                            [placeholder]="'Select ' + column.header.toLowerCase()"
                            [compareWith]="compareWith"
                            multiple>
                  @for (option of getSelectOptions(column.key); track option.value) {
                    <mat-option [value]="option.value">{{ option.label }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            } @else if (isEditing(item) && isEditableColumn(column.key)) {
              <mat-form-field appearance="fill" class="edit-field">
                <input matInput
                       [(ngModel)]="editingValues[column.key]"
                       (keydown)="onKeyDown($event, item)"
                       (click)="$event.stopPropagation()"
                       [type]="isNumberColumn(column.key) ? 'number' : 'text'"
                       appTextNormalize
                       #editInput>
              </mat-form-field>
            } @else if (isEditing(item) && isBooleanColumn(column.key) && column.editable) {
              <mat-checkbox [(ngModel)]="editingValues[column.key]"
                           (click)="$event.stopPropagation()"
                           class="boolean-checkbox">
              </mat-checkbox>
            } @else if (isEditing(item) && isSelectColumn(column.key) && column.editable) {
              <mat-form-field appearance="fill" class="edit-field">
                <mat-select [(ngModel)]="editingValues[column.key]"
                            (click)="$event.stopPropagation()"
                            [compareWith]="compareWith">
                  @for (option of getSelectOptions(column.key); track option.value) {
                    <mat-option [value]="option.value">{{ option.label }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            } @else if (isEditing(item) && isMultiSelectColumn(column.key) && column.editable) {
              <mat-form-field appearance="fill" class="edit-field">
                <mat-select [(ngModel)]="editingValues[column.key]"
                            (click)="$event.stopPropagation()"
                            [compareWith]="compareWith"
                            multiple>
                  @for (option of getSelectOptions(column.key); track option.value) {
                    <mat-option [value]="option.value">{{ option.label }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            } @else if (isBooleanColumn(column.key)) {
              @if (getColumnValue(item, column.key)) {
                <mat-icon class="boolean-check-icon">check</mat-icon>
              }
            } @else if (isSelectColumn(column.key)) {
              {{ getSelectColumnDisplayValue(item, column.key) }}
            } @else if (isMultiSelectColumn(column.key)) {
              <span [matTooltip]="getMultiSelectColumnTooltip(item, column.key)" matTooltipClass="multiline-tooltip">
                {{ getMultiSelectColumnDisplayValue(item, column.key) }}
              </span>
            } @else {
              {{ getColumnValue(item, column.key) }}
            }
          </td>
        </ng-container>
      }

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let item" class="actions-cell">
          <div class="action-buttons">
            @if (isAddingThisItem(item)) {
              <button mat-icon-button
                      (click)="saveAdd()"
                      class="save-button"
                      matTooltip="Save"
                      [disabled]="!hasValidEditingValues()">
                <mat-icon>check</mat-icon>
              </button>
              <button mat-icon-button
                      (click)="cancelAdd()"
                      class="cancel-button"
                      matTooltip="Cancel">
                <mat-icon>close</mat-icon>
              </button>
            } @else if (isEditing(item)) {
              <button mat-icon-button
                      (click)="saveEdit(item)"
                      class="save-button"
                      matTooltip="Save"
                      [disabled]="!hasValidEditingValues()">
                <mat-icon>check</mat-icon>
              </button>
              <button mat-icon-button
                      (click)="cancelEdit()"
                      class="cancel-button"
                      matTooltip="Cancel">
                <mat-icon>close</mat-icon>
              </button>
            } @else {
              @if (enableMatching) {
                <button mat-button
                        (click)="onMatchClick(item, $event)"
                        class="match-button"
                        [disabled]="isNewItem(item)"
                        [class.active]="getItemState(item) === 'matched'">
                  Match
                </button>
                <button mat-button
                        (click)="onRightClick(item, $event)"
                        class="right-button"
                        [disabled]="isNewItem(item)"
                        [class.active]="getItemState(item) === 'right'">
                  Right
                </button>
              }
              @if (isReadOnly(item)) {
                <button mat-icon-button
                        class="info-button"
                        matTooltip="System reserved data"
                        (click)="$event.stopPropagation()">
                  <mat-icon>info_outline</mat-icon>
                </button>
              } @else {
                <button mat-icon-button
                        (click)="onEditClick(item, $event)"
                        class="edit-button"
                        [disabled]="isNewItem(item) || !canEditItems()">
                  <mat-icon>edit</mat-icon>
                </button>
                <span [matTooltip]="protectedDeleteTooltip"
                      [matTooltipDisabled]="!isDeleteProtected(item)">
                  <button mat-icon-button
                          (click)="onDeleteClick(item, $event)"
                          class="delete-button"
                          [disabled]="isNewItem(item) || isDeleteProtected(item)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </span>
              }
            }
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" [class]="getRowClasses(row)"></tr>
    </table>

    @if (enablePaging) {
      <mat-paginator
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        [showFirstLastButtons]="true"
        [disabled]="isAddingNewItem"
        (page)="onPageChangeEvent($event)"
        aria-label="Select page">
      </mat-paginator>
    }
  } @else {
    <div class="empty-state">
      {{ emptyMessage }}
    </div>
  }
</div>
